import { RootState } from "@react-three/fiber";
import { Vector3 } from "three";
import { create } from "zustand";

type glRendererStoreType = {
  state?: RootState;
  setState: (st: RootState) => void;
};
export const useGLRendererStore = create<glRendererStoreType>()((set) => ({
  state: undefined,
  setState: (st: RootState) => set({ state: st }),
}));

type lookingAtPointStoreType = {
  lookingAt: Vector3;
  setLookingAt: (v3: Vector3) => void;
};

export const useLookingAtPointStore = create<lookingAtPointStoreType>()(
  (set) => ({
    lookingAt: new Vector3(0, 0, 0),

    setLookingAt: (v3: Vector3) => set({ lookingAt: v3 }),
  })
);

type compassHeadingType = {
  heading: number;
  headingDeg: number;
  setHeading: (number: number) => void;
};

export const useCompassHeadingStore = create<compassHeadingType>()((set) => ({
  heading: 0,
  headingDeg: 0,
  setHeading: (number: number) =>
    set({
      heading: number,
      headingDeg: Math.floor(180 + (-number * 180) / Math.PI),
    }),
}));

type cameraPositionType = {
  cameraLookAt: Vector3 | null;
  setCameraLookAt: (v3: Vector3) => void;
  resetCameraLookAt: () => void;
};

export const useCameraPositionStore = create<cameraPositionType>()((set) => ({
  cameraLookAt: null,
  setCameraLookAt: (v3: Vector3) => set({ cameraLookAt: v3.normalize() }),
  resetCameraLookAt: () => set({ cameraLookAt: null }),
}));
